import {
	EventType,
	IChatMessages,
	IChatEventChatMaximizedMessage,
	IChatEventChatMinimizedMessage,
	MessageType,
	IChatEventMessage,
	IChatEventPostbackMessage,
	IChatEventSurveyDataMessage,
	IChatEventWebMessageMessage,
	IChatEventChannelOpenData,
} from '../../types';

export const isEventMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatEventMessage => message?._type === MessageType.EVENT;

export const isEventMinimizedChatMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatEventChatMinimizedMessage =>
	isEventMessage(message) && message._data.name === EventType.CHAT_MINIMIZED;

export const isEventMaximizedChatMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatEventChatMaximizedMessage =>
	isEventMessage(message) && message._data.name === EventType.CHAT_MAXIMIZED;

export const isEventMessageSurveyData = <T extends IChatMessages>(
	message?: T,
): message is T & IChatEventSurveyDataMessage =>
	isEventMessage(message) && message._data.name === EventType.SURVEY_DATA;

export const isEventMessagePostback = <T extends IChatMessages>(
	message?: T,
): message is T & IChatEventPostbackMessage => {
	return isEventMessage(message) && message._data.name === EventType.POSTBACK;
};

export const isEventWebMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatEventWebMessageMessage =>
	isEventMessage(message) && message._data.name === EventType.WEB_MESSAGE;

export const isEventChannelOpenMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatEventMessage<IChatEventChannelOpenData> =>
	isEventMessage(message) && message._data.name === EventType.CHANNEL_OPEN;
